<template>
  <div>
    <!-- Block -->
    <div class="block">
      <!-- top search bar -->
      <div class="pa-5 d-flex">
        <div class="form-input-group flex-grow-1 mr-5">
          <div class="prepend-icon"><v-icon>search</v-icon></div>
          <input
            type="text"
            class="pl-42px"
            placeholder="搜尋"
            v-model="textFilter"
          />
        </div>
        <SimpleSelectWithSearchInput
          class="mr-5"
          buttonPlaceholder="篩選Type"
          buttonWidth="150px"
          modalWidth="150px"
          modalBodyHeight="208px"
          :options="['type1', 'type2']"
          :selectedValue.sync="typeFilter"
        ></SimpleSelectWithSearchInput>
        <SimpleSelectWithSearchInput
          class="mr-5"
          buttonPlaceholder="篩選年份"
          buttonWidth="150px"
          modalWidth="150px"
          modalBodyHeight="208px"
          :options="options.year"
          :selectedValue.sync="yearFilter"
        ></SimpleSelectWithSearchInput>
        <button class="btn btn-primary w-88px">搜尋</button>
      </div>

      <!-- table -->
      <div class="table">
        <div class="table-head">
          <!-- column head -->
          <div class="form-item d-flex px-5 h-60px align-center">
            <h5 class="col-id">id</h5>
            <h5 class="col-subject">Subject</h5>
            <h5 class="col-schedule-total-sent">Schedule Total Sent</h5>
            <h5 class="col-open-count-rate">Open Count Rate</h5>
            <h5 class="col-click-count-rate">Click Count Rate</h5>
            <h5 class="col-area">Area</h5>
            <h5 class="col-status">Status</h5>
            <h5 class="col-edit ml-auto">編輯</h5>
            <h5 class="col-delete">刪除</h5>
          </div>
        </div>
        <div class="table-body">
          <div
            class="form-item d-flex h-80px pt-5"
            v-for="item in filterNumPerPageTableList"
            :key="item.id"
          >
            <div class="h5 col-id">{{ item.id }}</div>
            <div class="h5 col-subject">{{ item.subject }}</div>
            <div class="h5 col-schedule-total-sent text-right">
              <div>20200706</div>
              <div>0</div>
            </div>
            <div class="h5 col-open-count-rate text-right">
              <div>7184</div>
              <div>6.88%</div>
            </div>
            <div class="h5 col-click-count-rate text-right">
              <div>603</div>
              <div>0.58%</div>
            </div>
            <div class="h5 col-area">
              {{ item.area }}
            </div>
            <div class="h5 col-status">
              {{ item.status }}
            </div>
            <div class="h5 col-edit ml-auto">
              <button class="btn square" @click="editItem">
                <v-icon>edit</v-icon>
              </button>
            </div>
            <div class="h5 col-delete">
              <deleteDialog
                @confirm-delete="deleteItem(item.id)"
              ></deleteDialog>
            </div>
          </div>
        </div>
      </div>

      <!-- table footer -->
      <div
        class="d-flex justify-end align-center h5"
        style="padding: 26px 20px;"
      >
        <!-- item per page -->
        <div class="mr-10px d-flex align-center">
          <span class="mr-10px">單頁顯示筆數</span>
          <TableNumPerPage
            v-model="numberOfItemsPerPage"
            @input="currentPage = 1"
          ></TableNumPerPage>
        </div>
        <!-- item total -->
        <div class="mr-10px">
          <span style="margin-right: 2px">{{ displayPageToPage() }}</span>
          <span>共 {{ filterTableList.length }}筆</span>
        </div>
        <!-- pre and next -->
        <div>
          <button class="btn square w-32px h-32px mr-4" @click="lastPage">
            <v-icon>navigate_before</v-icon>
          </button>
          <button class="btn square w-32px h-32px" @click="nextPage">
            <v-icon>navigate_next</v-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableNumPerPage from '@/components/TableNumPerPage.vue';
import deleteDialog from '@/components/C-1b__CategoriesList_Dialog-ConfirmDelete.vue';
import SimpleSelectWithSearchInput from '@/components/Selection/SimpleSelectWithSearchInput.vue';

export default {
  components: {
    TableNumPerPage,
    deleteDialog,
    SimpleSelectWithSearchInput,
  },
  data: () => ({
    // filter
    textFilter: '',
    typeFilter: '',
    yearFilter: '',
    // options
    options: {
      year: [...Array(100).keys()].map((i) => `${i + 2001}`),
    },
    // tablelist
    tableList: [
      {
        id: '1801',
        subject: 'Shop ADATA special: subject wowo XENIA+PRECOG Combo!',
        scheduleTotalSent: 20200706,
        openCountRate: 7184,
        clickCountRate: 603,
        area: 'United States',
        status: 'Standby',
      },
      {
        id: '1802',
        subject: 'Shop ADATA special: subject wowo XENIA+PRECOG Combo!',
        scheduleTotalSent: 20200706,
        openCountRate: 7184,
        clickCountRate: 603,
        area: 'United States',
        status: 'Standby',
      },
      {
        id: '1803',
        subject: 'Shop ADATA special: subject wowo XENIA+PRECOG Combo!',
        scheduleTotalSent: 20200706,
        openCountRate: 7184,
        clickCountRate: 603,
        area: 'United States',
        status: 'Standby',
      },
    ],
    numberOfItemsPerPage: '10', // at bottom table footer
    currentPage: 1,
  }),
  computed: {
    filterTableList() {
      const vm = this;
      return (
        this.tableList
          // textFilter
          .filter((item) => item.subject.toLowerCase().includes(vm.textFilter))
      );
    },
    filterNumPerPageTableList() {
      const vm = this;
      return this.filterTableList.filter((item, i) => {
        if (vm.numberOfItemsPerPage === 'All') return true;
        return (
          i <= Number(vm.numberOfItemsPerPage) * vm.currentPage - 1 &&
          i >= Number(vm.numberOfItemsPerPage) * (vm.currentPage - 1)
        );
      });
    },
  },
  methods: {
    editItem() {
      this.$router.push({ path: '/edm-send-list/edit' });
    },
    deleteItem(itemId) {
      const index = this.tableList.findIndex((item) => item.id === itemId);
      this.tableList.splice(index, 1);
      console.log(index);
    },
    stampToDate(stamp) {
      const dateObj = new Date(stamp);
      const year = dateObj.getFullYear();
      const month = dateObj.getMonth() + 1;
      const date = dateObj.getDate();

      return `${year}年${month}月${date}日`;
    },
    lastPage() {
      if (this.currentPage === 1) {
        return;
      }
      this.currentPage -= 1;
    },
    nextPage() {
      if (this.numberOfItemsPerPage === 'All') return;
      if (
        this.currentPage * Number(this.numberOfItemsPerPage) >
        this.filterTableList.length
      ) {
        return;
      }
      this.currentPage += 1;
    },
    displayPageToPage() {
      let left;
      let right;

      const filterLength = this.filterTableList.length;
      const perPageLength = Number(this.numberOfItemsPerPage);

      if (this.numberOfItemsPerPage === 'All') {
        left = 1;
        right = filterLength;
      } else {
        left = 1 + perPageLength * (this.currentPage - 1);
        right = perPageLength * this.currentPage;
        if (perPageLength * this.currentPage > filterLength) {
          right = filterLength;
        }
      }

      return `${left}-${right}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  .col-id {
    width: 30px;
    margin-right: 20px;
  }
  .col-subject {
    width: 248px;
    margin-right: 26px;
  }
  .col-schedule-total-sent {
    width: 68px;
    margin-right: 40px;
    text-align: right;
  }
  .col-open-count-rate {
    width: 81px;
    margin-right: 40px;
    text-align: right;
  }
  .col-click-count-rate {
    width: 79px;
    margin-right: 40px;
    text-align: right;
  }
  .col-area {
    width: 86px;
    margin-right: 40px;
    text-align: right;
  }
  .col-status {
    width: 53px;
    margin-right: 40px;
    text-align: right;
  }
}
</style>
